export default "__VITE_ASSET__BbTMWC3C__"